<template>
  <v-container class="pa-0">
    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="users"
          :items-per-page="10"
          class="elevation-1"
          locale="pt"
        >
          <template
            v-slot:item.action="{ item }"
            style="position: relative"
            v-if="admin"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  class="mr-2"
                  @click="changeNameOpen(item)"
                >
                  mdi-account
                </v-icon>
              </template>
              <span>Mudar o nome</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  class="mr-2"
                  @click="changePasswordOpen(item)"
                >
                  mdi-lock-reset
                </v-icon>
              </template>
              <span>Trocar a senha</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  class="mr-2"
                  @click="deleteUserOpen(item)"
                >
                  mdi-delete-empty
                </v-icon>
              </template>
              <span>Excluir usuário</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on"> Novo usuário </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Novo usuário
            </v-card-title>

            <v-card-text>
              <v-text-field v-model="name" label="Nome"></v-text-field>
              <v-text-field v-model="email" label="Email"></v-text-field>
              <v-text-field v-model="password" label="Senha"></v-text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="newUser"
                :loading="loading"
                :disabled="name === '' || email === '' || password === ''"
              >
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <v-dialog v-model="deleteUserModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Remover usuário
        </v-card-title>

        <v-card-text v-if="deleteUserUser" class="mt-4">
          Essa ação não poderá ser desfeita. Deseja remover <code>{{ deleteUserUser.name }}</code> ?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteUserModal = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="deleteUserApi"> Excluir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changePasswordModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Alterar senha
        </v-card-title>

        <v-card-text v-if="changePasswordUser" class="mt-4">
          <p>
            Insira uma nova senha para
            <code>{{ changePasswordUser.name }}</code>
          </p>
          <v-text-field v-model="password" label="Senha"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="changePasswordModal = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changePasswordApi"
            :disabled="password === ''"
          >
            Alterar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changeNameModal" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Alterar Nome
        </v-card-title>

        <v-card-text v-if="changeNameUser" class="mt-4">
          <p>
            Insira um novo nome para <code>{{ changeNameUser.name }}</code>
          </p>
          <v-text-field v-model="name" label="Nome"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="changeNameModal = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changeNameApi"
            :disabled="name === ''"
          >
            Alterar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      name: '',
      email: '',
      password: '',
      loading: false,
      dialog: false,
      deleteUserModal: false,
      deleteUserUser: null,
      changePasswordModal: false,
      changePasswordUser: null,
      changeNameModal: false,
      changeNameUser: null,
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: '', value: 'action', sortable: false, align: 'right' }
      ]
    }
  },
  methods: {
    changeNameOpen (item) {
      this.changeNameUser = item
      this.name = item.name
      this.changeNameModal = true
    },
    changePasswordOpen (item) {
      this.changePasswordUser = item
      this.changePasswordModal = true
    },
    deleteUserOpen (item) {
      this.deleteUserUser = item
      this.deleteUserModal = true
    },
    async changeNameApi () {
      try {
        await axios.post(
          '/AlterarUsuario',
          {},
          {
            params: {
              idUsuario: this.id,
              idUsuarioAlteracao: this.changeNameUser.id,
              nome: this.name,
              senha: ''
            }
          }
        )
        this.$store.commit('auth/updateName', {
          id: this.changeNameUser.id,
          name: this.name
        })
        this.$store.commit('snackbar/show', {
          text: 'Nome alterado',
          color: 'success'
        })
        this.changeNameModal = false
        this.changeNameUser = null
      } catch (error) {
        console.log(error)
        this.$store.commit('snackbar/show', {
          text: 'Ocorreu um erro',
          color: 'error'
        })
      }
    },
    async changePasswordApi () {
      try {
        await axios.post(
          '/AlterarUsuario',
          {},
          {
            params: {
              idUsuario: this.id,
              idUsuarioAlteracao: this.changePasswordUser.id,
              senha: this.password,
              nome: this.changePasswordUser.name
            }
          }
        )
        this.$store.commit('snackbar/show', {
          text: 'Senha alterada',
          color: 'success'
        })
        this.changePasswordModal = false
        this.changePasswordUser = null
      } catch (error) {
        console.log(error)
        this.$store.commit('snackbar/show', {
          text: 'Ocorreu um erro',
          color: 'error'
        })
      }
    },
    async deleteUserApi () {
      try {
        await axios.post(
          '/ExcluirUsuario',
          {},
          {
            params: {
              idUsuarioExclusao: this.deleteUserUser.id,
              idUsuario: this.id
            }
          }
        )
        this.$store.commit('auth/deleteUser', this.deleteUserUser.id)
        this.$store.commit('snackbar/show', {
          text: 'Usuario excluido',
          color: 'info'
        })
        this.deleteUserModal = false
        this.deleteUserUser = null
      } catch (error) {
        console.log(error)
        this.$store.commit('snackbar/show', {
          text: 'Ocorreu um erro',
          color: 'error'
        })
      }
    },
    async newUser () {
      try {
        this.loading = true
        const { data: result } = await axios.post(
          '/CriarUsuario',
          {},
          {
            params: {
              nome: this.name,
              usuario: this.email,
              senha: this.password
            }
          }
        )
        this.$store.commit('snackbar/show', {
          text: 'Usuario cadastrado',
          color: 'success'
        })
        this.$store.commit('auth/pushUser', {
          id: result,
          name: this.name,
          email: this.email
        })
        this.dialog = false
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
        this.$store.commit('snackbar/show', {
          text: 'Ocorreu um erro',
          color: 'error'
        })
      }
    }
  },
  watch: {
    dialog () {
      this.name = ''
      this.email = ''
      this.password = ''
    },
    changeNameModal () {
      this.name = ''
    },
    changePasswordModal () {
      this.password = ''
    }
  },
  computed: {
    ...mapGetters('auth', ['users', 'admin', 'id'])
  }
}
</script>

<style>
</style>
